export default __webpack_public_path__ + "locales/de/Settings.json?hash=26c72e4b0bb07df18edbc644a4e31f16";